// Page-level back gesture: wraps a page's content so an edge swipe navigates
// to its parent route (the same target as the header back chevron). The
// gesture core lives in useEdgeSwipe, shared with SheetShell's swipe-to-close.
import { useRef, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useEdgeSwipe } from "./useEdgeSwipe";

export function SwipeBack({ backTo, children, className = "" }: {
  /** Route to navigate to on a completed swipe, "history" to walk back to
   *  wherever the user came from, or null to disable the gesture. */
  backTo: string | null;
  children: ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const backRef = useRef(backTo);
  backRef.current = backTo;

  useEdgeSwipe(ref, {
    enabled: !!backTo,
    onCommit: () => { const t = backRef.current; if (t === "history") navigate(-1); else if (t) navigate(t); },
  });

  return <div ref={ref} className={className}>{children}</div>;
}
